<style lang="scss">
    .relogio-de-ponto {
        .action-card-text {
            min-height: 500px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .iframe {
            width: 100% !important;
            height: 400px;;

            iframe {
                width: 100% !important;
                height: 100% !important;
            }
        }
        .alert {
            min-width: 600px;
        }
    }
</style>

<template>
    <div class="relogio-de-ponto">
        <v-container>
            <v-card>
                <v-card-title>
                    Relógio de Ponto
                    <v-spacer></v-spacer>
                    <v-btn href="/storage/folha_de_ponto.pdf" target="blank" color="primary" text>
                        Última extração <v-icon right>mdi-open-in-new</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="action-card-text">
                    <div v-if="loading" class="text-center">
                       <v-progress-circular color="primary" indeterminate class="mb-3"></v-progress-circular><br>
                       <span class="subtitle-1">Carregando</span><br>
                       <span class="caption">Pode levar alguns minutos...</span>
                       <span class="caption">Nós avisaremos se houver algum problema, não saia da página</span>
                    </div>
                    <div v-else-if="hasError" class="text-center">
                        <v-alert type="error" text class="alert text-left">
                            <div class="title">
                                Ocorreu um erro
                            </div>
                            <div>{{error}}</div>
                        </v-alert>
                        <v-btn @click="handleTryAgain" color="primary">Tentar novamente</v-btn>
                    </div>
                    <div v-else-if="ready" class="text-center">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                        <v-btn href="/storage/folha_de_ponto.pdf" target="blank" color="primary" text>
                            Folha de ponto.pdf
                        </v-btn>
                    </div>
                    <div v-else-if="file" class="text-center">
                       <v-icon size="50">mdi-file-check-outline</v-icon><br>
                       <span class="subtitle-1">Arquivo carregado</span><br>
                       <span class="caption">{{ file.name }}</span><br>
                       <v-btn @click="handleClickGenerateReport" color="success" class="mt-10">Gerar folha de ponto</v-btn>
                       <br>
                       <v-btn small @click="handleCancel" color="secondary" class="mt-5" text>Escolher outro arquivo</v-btn>
                    </div>
                    <div v-else>
                        <v-btn @click="handleClickSendFileInput" color="primary">
                            <v-icon left>mdi-upload</v-icon> Enviar arquivo
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-container>
        <input
            @change="changeFile"
            type="file"
            ref="fileInput"
            v-show="false"
            accept=".xls"
        />
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            file: null,
            hasError: false,
            error: "",
            ready: false
        };
    },

    methods: {
        handleClickSendFileInput() {
            console.log(this.$refs.fileInput);
            this.$refs.fileInput.click();
        },
        changeFile(event) {
            console.log(event.target.files[0]);
            this.file = event.target.files[0];
        },
        handleCancel() {
            this.file = null;
            this.$refs.fileInput.value = null;
        },
        handleTryAgain() {
            this.file = null;
            this.$refs.fileInput.value = null;
            this.hasError = false;
        },
        async handleClickGenerateReport() {
            let data = new FormData();
            data.append('file', this.file);
            
            this.loading = true;
            try {
                const response = await this.$http.post("/relogio_de_ponto", data);
                this.ready = true;

                this.file = null;
                this.$refs.fileInput.value = null;
            } catch(error) {
                this.error = error.response.data.message;
                this.hasError = true;
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>